export const timeZoneOffset = (timeZone = 'UTC', date = new Date()) => {
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));

  const offsetMinutes = (tzDate.getTime() - utcDate.getTime()) / (60 * 1000);
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const hours = Math.floor(Math.abs(offsetMinutes) / 60);
  const minutes = Math.abs(offsetMinutes) % 60;

  const paddedHours = (hours < 10 ? '0' : '') + hours;
  const paddedMinutes = (minutes < 10 ? '0' : '') + minutes;

  return `${sign}${paddedHours}:${paddedMinutes}`;
};
